var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#E0DEDD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 47,
    r: 14,
    fill: "#9E9A98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 90c0-13.807 11.193-25 25-25s25 11.193 25 25",
    fill: "#9E9A98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralAvatar);
export default __webpack_public_path__ + "static/media/neutral-avatar.c5f5ffdc02e194619bd0cc8237abd50d.svg";
export { ForwardRef as ReactComponent };